/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 User = {
    login: {
        toggle: function() {
            $(".user-toggle-login.login-button").toggleClass('active');

            var box = $(".user-box-login");

            if (box.css('display') == 'none') {
                box.fadeIn();

                if ($(this).hasClass('user-toggle-login-scroll')) {
                    $('html,body').animate({
                        scrollTop: box.offset().top
                    }, 'slow');
                }
            } else {
                box.fadeOut();
            }
        },
        updateAvatar: function() {
            var username = $(this).val();

            if (username == '') {
                $(".user-habbo-avatar").attr('style', '');
            } else {
                $(".user-habbo-avatar").css({
                    'background-image': 'url(https://www.habbo.com.br/habbo-imaging/avatarimage?img_format=gif&user='+username+'&action=std&direction=2&head_direction=3&gesture=sml&size=b)',
                    'background-position': '-5px -21px'
                });
            }
        },
        send: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var username = form.find('input[name="username"]').val();
            var password = form.find('input[name="password"]').val();
            var remember = form.find('input[name="remember"]').is(":checked");

            if (username && password) {
                form.addClass('disabled').animate({'opacity': 0.5});

                $.ajax({
                    url: '/a/user/login/send',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        'username': username,
                        'password': password,
                        'remember': remember
                    }
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == 'error') {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao logar",
                            content: message,
                            type: 'error'
                        });
                    } else if (data.status == 'success') {
                        location.reload();
                    }
                });
            } else {
                form.effect('shake', { distance: 3 });
            }
        }
    },
    register: {
        toggle: function() {
            var box = $(".register-user-area");

            if (box.css('display') == 'none') {
                box.show('scale');
            } else {
                box.hide('scale');
            }
        },
        usernameError: false,
        checkUsername: function() {
            var input = $(this);

            var username = input.val();

            $.ajax({
                url: '/a/user/register/checkUsername',
                type: 'POST',
                dataType: 'json',
                data: {'username': username},
            }).done(function(data) {
                $(".register-check-username-text").remove();

                if (data.isUsed) {
                    input.parent().append('<small class="register-check-username-text form-text text-danger">Este nome de usuário já está sendo utilizado.</small>');
                    User.register.usernameError = true;
                } else {
                    input.parent().append('<small class="register-check-username-text form-text text-success">Nome de usuário disponível.</small>');
                    User.register.usernameError = false;
                }
            });
        },
        emailError: false,
        checkEmail: function() {
            var input = $(this);

            var email = input.val();

            $.ajax({
                url: '/a/user/register/checkEmail',
                type: 'POST',
                dataType: 'json',
                data: {'email': email},
            }).done(function(data) {
                if (data.isUsed) {
                    input.parent().find('.form-text.text-muted').fadeOut(function() {
                        input.parent().append('<small class="register-check-email-text form-text text-danger">Este e-mail já está sendo utilizado.</small>');
                    });

                    User.register.emailError = true;
                } else {
                    input.parent().find('.form-text.text-muted').fadeIn();

                    $(".register-check-email-text").remove();
                    User.register.emailError = false;
                }
            });
        },
        passwordError: false,
        checkPassword: function() {
            var input = $(this);

            var password = input.val();

            $(".register-check-password-text").remove();

            if (password.length < 6 || password == '123456') {
                input.parent().find('.form-text.text-muted').fadeOut(function() {
                    input.parent().append('<small class="register-check-password-text form-text text-danger">A senha digitada é muito fácil de ser adivinhada. Por favor, utilize uma senha mais forte.</small>');
                });

                User.register.passwordError = true;
            } else {

                input.parent().find('.form-text.text-muted').fadeIn();
                User.register.passwordError = false;
            }
        },
        send: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var username = form.find('input[name="username"]').val();
            var email    = form.find('input[name="email"]').val();
            var password = form.find('input[name="password"]').val();

            if (username && email && password && !User.register.usernameError && !User.register.emailError && !User.register.passwordError) {
                form.addClass('disabled').animate({'opacity': 0.5});

                $.ajax({
                    url: '/a/user/register/send',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        'username': username,
                        'email': email,
                        'password': password
                    }
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == 'error') {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao registrar",
                            content: message,
                            type: 'error'
                        });
                    } else if (data.status == 'success') {
                        Alertbox({
                            title: "Registrado com sucesso!",
                            content: 'Você agora possui uma conta na ProHabbo para aproveitar o site! Já logamos você, vamos recarregar a página agora...',
                            type: 'success'
                        });

                        setTimeout(function() {
                            location.reload();
                        }, 3000);
                    }
                });
            } else {
                form.effect('shake', { distance: 3 });
            }
        }
    },
    logout: {
        show: function() {
            var html = '';

            html += '<form class="form-user-logout">';
            html += 'Tem certeza de que deseja deslogar da ProHabbo?<br><br>';
            html += '<center><button type="submit" class="btn btn-danger">Sair</button></center>';
            html += '</form>';

            Alertbox({
                title: "Sair",
                content: html,
                type: 'error'
            });
        },
        send: function(e) {
            e.preventDefault();

            $.ajax({
                url: '/a/user/logout',
                type: 'POST',
                dataType: 'json'
            }).done(function(data) {
                User.logout.sending = false;

                if (data.status == 'success') {
                    location.reload();
                } else if (data.status == 'error') {
                    Alertbox({
                        title: "Error ao deslogar",
                        content: "Ocorreu um erro ao sair de sua conta. Tente novamente.",
                        type: "error"
                    });
                }
            });
        }
    },
    profilePopup: {
        show: function() {
            var username = $(this).data('username');

            var offset = $(this).offset();
            var height = $(this).height();

            var top = (offset.top + height) + 7;
            var left = offset.left;

            $(this).uniqueId();
            var boxId = $(this).attr('id');
            var popup = $("#user-profile-"+boxId);

            if (popup.length) {
                popup.fadeOut('normal', function() {
                    popup.remove();
                });
            } else {
                $(".user-profile-popup").fadeOut('normal', function() {
                    $(this).remove();
                });

                $.ajax({
                    url: '/a/user/getPopup',
                    type: 'POST',
                    dataType: 'json',
                    data: {'username': username, 'top': top, 'left': left, 'boxId': boxId},
                }).done(function(data) {
                    $('body').append(data.html);
                    $("#user-profile-"+boxId).fadeIn();

                    Main.plugins.tooltip();
                });
            }
        }
    },
    follow: function(e) {
        var button = $(this);

        var id = button.data('id')

        if (button.hasClass('disabled')) {
            return false;
        }

        button.addClass('disabled');

        $.ajax({
            url: '/a/user/follow',
            type: 'POST',
            dataType: 'json',
            data: {'id': id},
        }).done(function(data) {
            button.removeClass('disabled');

            if (data.changeTo == 'follow') {
                button.removeClass('red').addClass('green');
                button.find('i').removeClass('fa-user-times').addClass('fa-user-plus');
                button.find('span').text('Seguir');
            } else if (data.changeTo == 'unfollow') {
                button.removeClass('green').addClass('red');
                button.find('i').removeClass('fa-user-plus').addClass('fa-user-times');
                button.find('span').text('Deixar de seguir');
            }
        });
    },
    activity: {
        unfollow: function(e) {
            var button = $(this);

            var id = button.data('id');

            if (button.hasClass('disabled')) {
                return false;
            }

            button.addClass('disabled');

            $.ajax({
                url: '/a/user/follow',
                type: 'POST',
                dataType: 'json',
                data: {'id': id},
            }).done(function(data) {
                button.removeClass('disabled');

                if (data.changeTo == 'follow') {
                    button.removeClass('red').addClass('green');
                    button.text('Seguir');
                } else if (data.changeTo == 'unfollow') {
                    button.removeClass('green').addClass('red');
                    button.text('Deixar de seguir');
                }
            });
        }
    },
    winFreeBadge: function() {
        var button = $(this);

        if (button.hasClass('disabled')) {
            return false;
        }

        var id = button.data('id');

        if (id > 0) {
            button.addClass('disabled');

            $.ajax({
                url: '/a/user/winFreeBadge',
                type: 'POST',
                dataType: 'json',
                data: {
                    'id': id
                },
            }).done(function(data) {
                button.removeClass('disabled');

                if (data.status == "error") {
                    var message = "";

                    for (i = data.messages.length - 1; i >= 0; i--) {
                        message += data.messages[i];

                        if (i > 0) {
                            message += '<br>';
                        }
                    }

                    Alertbox({
                        title: "Erro",
                        content: message,
                        type: 'error'
                    });
                } else if (data.status == "success") {
                    button.remove();
                    $(".tooltip").remove();

                    Alertbox({
                        title: "Emblema adquirido com sucesso!",
                        content: 'O emblema foi adicionado ao seu inventário.',
                        type: 'success'
                    });
                }
            });
        }
    },
    checkMentionsOnInput: function() {

        var el = $(this);

        if (!el.hasClass('ui-autocomplete-input')) {
            el.bind( "keydown", function( event ) {
                if (event.keyCode === $.ui.keyCode.TAB && $( this ).autocomplete( "instance" ).menu.active) {
                    event.preventDefault();
                }
            }).autocomplete({
                minLength: 1,
                source: function(request, response) {
                    var lastword = extractLast(request.term);
                    var matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex( lastword ), "i");

                    if (lastword.charAt(0) == "@") {
                        $.ajax({
                            url: '/a/user/getList',
                            type: 'POST',
                            dataType: 'json',
                            data: {
                                'search': lastword
                            }
                        }).done(function(data) {
                            var results = $.grep(data.usernames, function(item) {
                                return matcher.test(item);
                            });

                            response($.ui.autocomplete.filter(results, lastword));
                        });
                    }

                    return false;
                },
                focus: function() {
                    return false;
                },
                select: function( event, ui ) {
                    var terms = split(this.value);
                    terms.pop();
                    terms.push( ui.item.value );
                    terms.push( "" );
                    this.value = terms.join( " " );
                    return false;
                }
            });
        }
    },
    init: function() {
        $(".user-toggle-login, .user-box-close").on('click', User.login.toggle);
        $(".login-form input[name='username']").keyup(User.login.updateAvatar);
        $(".login-form").on('submit', User.login.send);

        $(".open-user-register, .register-area-close").on('click', User.register.toggle);
        $(".register-form").on('submit', User.register.send);

        $(".register-form").on('change', 'input[name="username"]', User.register.checkUsername);
        $(".register-form").on('change', 'input[name="email"]', User.register.checkEmail);
        $(".register-form").on('change', 'input[name="password"]', User.register.checkPassword);

        $(".user-welcome").on('click', function() {
            var el = $("section.user-area");

            $("html, body").animate({
                scrollTop: el.offset().top
            },'slow');
        });

        $('#user-notifications-dropdown').parent().on('show.bs.dropdown', function () {
            $.post('/a/user/notifications/mark-as-read');

            var currentNumber = parseInt($(".notifications-pendent-number").text());
            var totalNumber = parseInt($(".user-total-notifications-number").text());

            var newTotalNumber = totalNumber - currentNumber;

            if (newTotalNumber > 0) {
                $(".user-total-notifications-number").text(newTotalNumber);
            } else {
                $(".user-total-notifications-number").remove();
            }

            $(".notifications-pendent-number").remove();
        });

        $('#user-activity-dropdown').parent().on('show.bs.dropdown', function () {
            $.post('/a/user/activity/mark-as-read');

            var currentNumber = parseInt($(".activity-pendent-number").text());
            var totalNumber = parseInt($(".user-total-notifications-number").text());

            var newTotalNumber = totalNumber - currentNumber;

            if (newTotalNumber > 0) {
                $(".user-total-notifications-number").text(newTotalNumber);
            } else {
                $(".user-total-notifications-number").remove();
            }

            $(".activity-pendent-number").remove();
        });

        $(".user-notifications-list, .user-activity-list").slimScroll({
            height: '200px'
        });

        $(".user-logout-button").on('click', User.logout.show);
        $(document).on('submit', '.form-user-logout', User.logout.send);

        $("#user-area-messages-button").on('click', function() {
            var shout = $(".shoutbox");

            if (shout.data('status') == 'closed') {
                Shoutbox.toggle();
            } else {
                shout.effect('bounce', { times: 2, distance: 10 });
            }
        });

        $(".user-activity-unfollow-button").on('click', User.activity.unfollow);

        $(".free-badge-box").on('click', User.winFreeBadge);

        $(document).on('click', "[data-toggle='user-popup']", User.profilePopup.show);
        $(document).on('click', ".user-follow-button", User.follow);

        $(document).on('focus', '.input-enable-mention-user', User.checkMentionsOnInput);
    }
};

$(document).ready(function() {
    User.init();
});

